// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__28ab2","logo":"MainNavigation_logo__3UrbJ","active":"MainNavigation_active__3Yc_2","badge":"MainNavigation_badge__2NRf5"};